import {user} from "@/functions/user";

const setAppYear = () => {
    const currentTaxYear = process.env.VUE_APP_CURRENT_TAX_YEAR
    const minPriorTaxYear = process.env.VUE_APP_MIN_PRIOR_TAX_YEAR
    const params = new URLSearchParams(window.location.search)
    const urlAppYear = params.get('appYear')
    const urlAppYearInt = parseInt(urlAppYear)
    
    let finalAppYear;
    
    // Priority 1: Valid URL parameter
    if (urlAppYear && !isNaN(urlAppYearInt) && urlAppYearInt >= minPriorTaxYear) {
        finalAppYear = urlAppYearInt.toString()
    }
    // Priority 2: Session storage
    else if (sessionStorage.getItem('appYear')) {
        finalAppYear = sessionStorage.getItem('appYear')
    }
    // Priority 3: Default to env var
    else {
        finalAppYear = currentTaxYear
    }
    
    // Update both sessionStorage and user.appYear
    sessionStorage.setItem('appYear', finalAppYear)
    user.appYear = finalAppYear
}

export default setAppYear